import React from 'react'
import { Checkbox, Label } from './component.styles'

export interface CustomCheckBoxProps {
  checked?: boolean
  isDisabled?: boolean
  name?: string
  text?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const CustomCheckBox: React.FC<CustomCheckBoxProps> = ({
  checked,
  isDisabled,
  name,
  text,
  onChange,
}) => {
  return (
    <Label>
      <Checkbox
        checked={checked}
        disabled={isDisabled}
        name={name}
        onChange={onChange}
      />
      {text}
    </Label>
  )
}
